import React from 'react'
import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { GRAY_COLORS } from '../colors.constant'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  h6: {
    fontSize: 18,
    fontWeight: 600,
    color: GRAY_COLORS[800]
  },
  body2: {
    color: GRAY_COLORS[700]
  }
}))
const AsterTypography = ({ variant, children, className, ...props }) => {
  const classes = useStyles()
  return (
    <Typography
      className={clsx(className, classes[variant])}
      variant={variant}
      {...props}
    >
      {children}
    </Typography>
  )
}
export default AsterTypography
